export const isGlobalGroup = (group) => {
  const option = group?.options?.find((option) => option.name === 'is_global');

  return !!(option && option.value);
};
